import React, { PropsWithChildren, useContext, useEffect, useState } from "react";
import { BaseContext } from "../shared/base-context";
import { Navigate, useLocation } from "react-router-dom";
import { MainRoutes } from "../shared/models";
import { Spinner } from "../catalyst-components/spinner";
import { useConvexAuth } from "convex/react";
import { usePresence } from "../shared/hooks/usePresence";

export const AdminRoute: React.FC<PropsWithChildren> = ({children}) => {
    const { isAdmin, isAuthenticationComplete } = useContext(BaseContext);
    const [isLoading, setIsLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const { online, isOnline } = usePresence(MainRoutes.Chat);

    useEffect(() => {
        if (!isAuthenticationComplete) return;
        setIsLoading(false);
        setHasAccess(isAdmin);
    }, [isAdmin, isAuthenticationComplete]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Spinner className="w-16 h-16" />
            </div>
        );
    }

    if (!hasAccess) {
        return <Navigate to={MainRoutes.Landing} replace />;
    }

    return <>{children}</>;
};
